import j from './japanese.json'
import c from './cantonese.json'
import k from './korean.json'

export const japanese = j
export const cantonese = c
export const korean = k

export default {
  japanese: j,
  korean: k,
  cantonese: c
}
